/**
 * Feuille ouverte par défaut (31/10/2026) : quand la feuille de la question rapporte des HORA, le dock s'ouvre sur
 * le brouillon au lieu des touches de réponse. La feuille pour calculer (sans HORA) reste fermée. PUR.
 */
export function sheetOpensByDefault(
  session: { free: boolean; maxHora: number | null; getSnapshot(): { locked: boolean } } | null,
  v2Free = false,
): boolean {
  return (
    !!session &&
    !session.free &&
    !v2Free &&
    (session.maxHora ?? 0) > 0 &&
    !session.getSnapshot().locked
  );
}
